import React from 'react';
import { Users, FileText, UserCheck, Building2 } from 'lucide-react';
import './component.css';
import CountUp from 'react-countup';

const StatisticsSection = () => {
  const stats = [
    {
      icon: <Users size={24} />,
      number: "340",
      count: "M+",
      label: "ABHA Address Created"
    },
    {
      icon: <FileText size={24} />,
      number: "240",
      count: "M+",
      label: "Health Records Linked"
    },
    {
      icon: <UserCheck size={24} />,
      number: "152",
      count: "K+",
      label: "Verified Health Professionals"
    },
    {
      icon: <Building2 size={24} />,
      number: "200",
      count: "K+",
      label: "Verified Facilities"
    }
  ];

  return (
    <section className="statistics-section section">
      <div className="container">
        <div className="statistics-header">
          <h2 className="section-title">AYUSHMAN BHARAT DIGITAL MISSION</h2>
          <p className="section-subtitle">
            An initiative by the Indian Government to digitalize the health of Indian citizens. The mission aims to provide digital 
            ABHA Number to all citizens of India.
          </p>
        </div>

        <div className="statistics-grid">
          {stats.map((stat, index) => (
            <div key={index} className="stat-card">
              <div className="stat-icon">
                {stat.icon}
              </div>
              <CountUp end={stat.number} duration={5} separator="," />
              <span className="stat-count">{stat.count}</span>
              <div className="stat-label">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatisticsSection;